const stringIgnoreCase = (a: string, b: string): number => {
  if (!a) return -1;
  if (!b) return 1;
  return a.localeCompare(b);
};

const stringPropertyIgnoreCase = <T extends Record<StringProps<T>, string>>(key: StringProps<T>) => (a: T, b: T): number => stringIgnoreCase(a[key], b[key]);

type StringProps<T> = { [K in keyof T]: T[K] extends string ? K : never }[keyof T];

export { stringIgnoreCase, stringPropertyIgnoreCase };
